import MenuBar from './versions/0.0.1';

export default MenuBar;
